/**
 * @file        src/pages/flight/CorporateCouponList.jsx
 * @description Corporate Flight → Coupon List. Same list/form as the B2C
 *              Flight Coupon List (CouponList.jsx), fixed to audience=b2b,
 *              instead of forking the page.
 * @author      Kinetika Labs
 * @created     2026-08-10
 * @changelog
 *   - 2026-08-10 Claude — Initial (Corporate Flight menu parity with B2C).
 */
import CouponList from './CouponList';

export default function CorporateCouponList() {
  return (
    <CouponList
      title="Corporate Coupon List"
      subtitle="Corporate Flight · B2B coupon pool"
      audience="b2b"
    />
  );
}
